import { Injectable, NgModuleFactoryLoader } from '@angular/core';

import { OfficeRoute } from '../constants/office-route.enum';
import { CapabilitiesService } from '../shared-context/capabilities.service';
import { DocumentService } from './document.service';
import { SchedulePriority, SchedulerService } from './scheduler.service';

@Injectable({
    providedIn: 'root'
})
export class PreloadService {
private readonly routeModuleMap: ReadonlyMap<OfficeRoute, string> = new Map<OfficeRoute, string>([
        [OfficeRoute.Start, './start-page-wrapper/start-page-wrapper.module#StartPageWrapperModule'],
        [OfficeRoute.AppGallery, './app-gallery/app-gallery.module#AppGalleryModule'],
        [OfficeRoute.Templates, './templates/templates.module#TemplatesModule']
    ]);

    private readonly preloadedRoutes: Set<OfficeRoute> = new Set();
    private readonly prefetchedDns: Set<string> = new Set();

    constructor(
        private readonly capabilitiesService: CapabilitiesService,
        private readonly documentService: DocumentService,
        private readonly ngModuleLoader: NgModuleFactoryLoader,
        private readonly scheduler: SchedulerService
    ) {
    }

    public async preload(route: string | OfficeRoute) {
        if (!route) {
            return;
        }

        if (this.isOfficeRoute(route) && this.routeModuleMap.has(route)) {
            await this.preloadRoute(route);
        } else if (route.startsWith('https')) {
            this.prefetchDns(route);
        }
    }

    private isOfficeRoute(value: string | OfficeRoute): value is OfficeRoute {
        return !value.startsWith('http');
    }

    private async preloadRoute(route: OfficeRoute) {
        if (route === OfficeRoute.Start && !this.capabilitiesService.capabilities.wacStartPageEnabled) {
            return;
        }

        if (!this.preloadedRoutes.has(route)) {
            this.preloadedRoutes.add(route);
            await new Promise<any>(resolve => this.scheduler.scheduleWork(resolve, SchedulePriority.Low));
            await this.ngModuleLoader.load(this.routeModuleMap.get(route));
        }
    }

    private prefetchDns(urlOrigin: string) {
        if (!this.prefetchedDns.has(urlOrigin)) {
            this.prefetchedDns.add(urlOrigin);
            const attributes = new Map<string, string>([['rel', 'dns-prefetch'], ['href', urlOrigin]]);
            this.documentService.addLinkTag(attributes);
        }
    }
}
